import styled, { css } from 'styled-components'

interface Props {
  float?: boolean
  iconPlacement?: 'right' | 'left'
  isDisabled?: boolean
}

export const InputWrapper = styled.div<Props>`
  position: relative;
  display: flex;
  flex-direction: column;
  font-size: 1rem;

  & input:not([class*="dummy"]) {
    padding: ${({ float }) =>
      float ? '1.5rem 2.5rem 0.5rem' : '1.125rem 2.5rem 0.875rem'};
    padding-left: ${({ iconPlacement }) =>
      iconPlacement === 'left' ? '2.75rem' : '0.75rem'};
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      & * {
        pointer-events: none;
      }
    `}
`

export const InputContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  position: relative;
`
